/**
 * Grail27 hybrid cart upsell:
 * - Liquid may pre-render metafield / collection items
 * - Shopify recommendations fill remaining slots (idle / drawer-open)
 * - Add-to-cart: drawer section refresh off-/cart; full reload on /cart (keeps page + drawer in sync)
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 768px)';
  var addListenerBound = false;
  var drawerOpenBound = false;
  var cartUpdateBound = false;
  var resizeTimer;

  function isMobileView() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function isCartPage() {
    try {
      var path = window.location.pathname.replace(/\/+$/, '') || '/';
      return /\/cart$/i.test(path);
    } catch (e) {
      return false;
    }
  }

  function parseGapPx(container) {
    var g = window.getComputedStyle(container).gap;
    if (g && g.endsWith('px')) return parseFloat(g) || 12;
    return 12;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        var fmt =
          (window.theme && window.theme.moneyFormat) ||
          window.Shopify.money_format ||
          undefined;
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) {}
    }
    return 'AED ' + (cents / 100).toFixed(2);
  }

  function updateMobilePagedHeight(container) {
    if (!container || !container.classList.contains('grail-cart-upsell__container--paged')) return;
    if (container.closest('.grail-cart-upsell--drawer')) return;
    var items = container.querySelectorAll('.grail-cart-upsell__item');
    if (!isMobileView()) {
      container.style.maxHeight = '';
      return;
    }
    if (items.length < 2) {
      container.style.maxHeight = '';
      return;
    }
    var gap = parseGapPx(container);
    var h = items[0].offsetHeight + gap + items[1].offsetHeight;
    if (h < 48) return;
    container.style.maxHeight = h + 'px';
  }

  function updateAllMobilePagedHeights() {
    document.querySelectorAll('.grail-cart-upsell__container--paged').forEach(updateMobilePagedHeight);
  }

  function bindSlider(root) {
    var container = root.querySelector('[data-grail-upsell-track]');
    var prevBtn = root.querySelector('[data-grail-upsell-prev]');
    var nextBtn = root.querySelector('[data-grail-upsell-next]');
    if (!container || !prevBtn || !nextBtn) return;
    if (container.dataset.grailUpsellSliderBound === '1') return;
    container.dataset.grailUpsellSliderBound = '1';

    function step(dir) {
      var first = container.querySelector('.grail-cart-upsell__item');
      if (!first) return;
      if (isMobileView() && container.classList.contains('grail-cart-upsell__container--paged')) {
        var vh = container.clientHeight;
        var maxScroll = Math.max(0, container.scrollHeight - vh);
        var next = Math.min(maxScroll, Math.max(0, container.scrollTop + dir * vh));
        container.scrollTo({ top: next, behavior: 'smooth' });
        return;
      }
      var delta = first.offsetWidth + 12;
      container.scrollBy({ left: dir * delta, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      step(-1);
    });
    nextBtn.addEventListener('click', function () {
      step(1);
    });
  }

  function syncNav(root) {
    var nav = root.querySelector('[data-grail-upsell-nav]');
    var count = root.querySelectorAll('.grail-cart-upsell__item').length;
    if (!nav) return;
    if (count >= 3) nav.removeAttribute('hidden');
    else nav.setAttribute('hidden', '');
  }

  function syncVisibility(root) {
    if (!root) return;
    if (root.querySelector('.grail-cart-upsell__item')) {
      root.removeAttribute('hidden');
      root.style.display = '';
    } else if (root.getAttribute('data-reco-pending') === 'true') {
      root.setAttribute('hidden', '');
    } else {
      root.setAttribute('hidden', '');
    }
  }

  function firstAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return null;
  }

  function buildItemHtml(product) {
    var variant = firstAvailableVariant(product);
    if (!variant || !variant.id) return '';
    var img =
      product.featured_image ||
      (product.images && product.images[0]) ||
      '';
    if (img && typeof img === 'object') img = img.src || '';
    var title = escapeHtml(product.title || '');
    var url = escapeHtml(product.url || '#');
    var handle = escapeHtml(product.handle || '');
    var price = escapeHtml(formatMoney(product.price));
    var compare = '';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      compare =
        '<span class="grail-cart-upsell__compare">' +
        escapeHtml(formatMoney(product.compare_at_price)) +
        '</span>';
    }
    var imgTag = img
      ? '<img src="' + escapeHtml(String(img)) + '" alt="" width="64" height="64" loading="lazy" decoding="async">'
      : '';

    return (
      '<div class="grail-cart-upsell__item" data-handle="' +
      handle +
      '">' +
      '<a href="' +
      url +
      '" class="grail-cart-upsell__img">' +
      imgTag +
      '</a>' +
      '<div class="grail-cart-upsell__info">' +
      '<a href="' +
      url +
      '" class="grail-cart-upsell__link">' +
      title +
      '</a>' +
      '<div class="grail-cart-upsell__prices"><span class="grail-cart-upsell__price">' +
      price +
      '</span>' +
      compare +
      '</div></div>' +
      '<button type="button" class="grail-cart-upsell__add" data-grail-upsell-add data-variant-id="' +
      String(variant.id) +
      '" data-add-label="+ Add">+ Add</button></div>'
    );
  }

  function loadRecommendations(root) {
    if (!root || root.getAttribute('data-reco-pending') !== 'true') return;
    if (root.dataset.grailRecoLoading === '1' || root.dataset.grailRecoDone === '1') return;

    var productId = root.getAttribute('data-product-id');
    var intent = root.getAttribute('data-intent') || 'related';
    if (intent !== 'related' && intent !== 'complementary') intent = 'related';
    var remaining = parseInt(root.getAttribute('data-remaining'), 10) || 0;
    var existingCount = root.querySelectorAll('.grail-cart-upsell__item').length;
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 0;
    if (limit > 0) remaining = Math.max(0, limit - existingCount);
    var excludeIds = root.getAttribute('data-exclude-ids') || ',';
    var excludeHandles = root.getAttribute('data-exclude-handles') || ',';
    if (!productId || remaining < 1) {
      root.removeAttribute('data-reco-pending');
      root.dataset.grailRecoDone = '1';
      syncVisibility(root);
      return;
    }

    root.dataset.grailRecoLoading = '1';
    var url =
      rootUrl() +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      Math.min(10, remaining + 4) +
      '&intent=' +
      encodeURIComponent(intent);

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('reco');
        return res.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        var track = root.querySelector('[data-grail-upsell-track]');
        if (!track) return;
        var html = '';
        var added = 0;
        for (var i = 0; i < products.length && added < remaining; i++) {
          var p = products[i];
          if (!p || !p.available) continue;
          var tags = typeof p.tags === 'string' ? p.tags : (p.tags || []).join(',');
          if (tags.indexOf('grail-service') !== -1) continue;
          if (
            p.handle === 'uv-printed-number-plate' ||
            p.handle === 'premium-gift-wrapping'
          ) {
            continue;
          }
          var idNeedle = ',' + p.id + ',';
          var handleNeedle = ',' + (p.handle || '') + ',';
          if (excludeIds.indexOf(idNeedle) !== -1) continue;
          if (p.handle && excludeHandles.indexOf(handleNeedle) !== -1) continue;
          if (p.handle && root.querySelector('[data-handle="' + String(p.handle).replace(/"/g, '') + '"]')) {
            continue;
          }
          var chunk = buildItemHtml(p);
          if (!chunk) continue;
          html += chunk;
          if (p.handle) excludeHandles += p.handle + ',';
          excludeIds += p.id + ',';
          added += 1;
        }
        if (html) {
          track.insertAdjacentHTML('beforeend', html);
          track.classList.add('grail-cart-upsell__container--paged');
        }
        syncNav(root);
        updateMobilePagedHeight(track);
        root.setAttribute('data-exclude-ids', excludeIds);
        root.setAttribute('data-exclude-handles', excludeHandles);
      })
      .catch(function () {})
      .then(function () {
        root.dataset.grailRecoLoading = '0';
        root.dataset.grailRecoDone = '1';
        root.removeAttribute('data-reco-pending');
        syncVisibility(root);
      });
  }

  function shouldLazyReco(root) {
    if (!root || root.getAttribute('data-reco-pending') !== 'true') return false;
    if (root.getAttribute('data-context') === 'drawer') {
      var drawer = document.querySelector('cart-drawer');
      return !!(drawer && drawer.classList.contains('active'));
    }
    return true;
  }

  function scheduleReco(root) {
    if (!shouldLazyReco(root)) return;
    var run = function () {
      loadRecommendations(root);
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 2500 });
    } else {
      setTimeout(run, 200);
    }
  }

  function initRoots(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var roots = base.querySelectorAll('[data-grail-cart-upsell]');
    roots.forEach(function (root) {
      bindSlider(root);
      syncNav(root);
      syncVisibility(root);
      scheduleReco(root);
    });
    updateAllMobilePagedHeights();
  }

  function refreshCartSections(sectionsPayload) {
    var drawer = document.querySelector('cart-drawer');
    if (
      !drawer ||
      typeof drawer.renderContents !== 'function' ||
      !sectionsPayload ||
      !sectionsPayload.sections ||
      !sectionsPayload.sections['cart-drawer']
    ) {
      return false;
    }
    try {
      drawer.renderContents(sectionsPayload);
      initRoots(drawer);
      return true;
    } catch (e) {
      return false;
    }
  }

  function onAddClick(event) {
    var btn = event.target.closest('[data-grail-upsell-add]');
    if (!btn || btn.disabled) return;

    var raw = btn.getAttribute('data-variant-id');
    var variantId = parseInt(raw, 10);
    if (!Number.isFinite(variantId) || variantId < 1) return;

    event.preventDefault();

    var label = btn.getAttribute('data-add-label') || btn.textContent.trim() || '+ Add';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = '…';

    var hasDrawer = !!document.querySelector('cart-drawer');
    var onCart = isCartPage();
    var body = {
      items: [{ id: variantId, quantity: 1 }],
    };

    // Cart page: full reload keeps cart sections + drawer HTML in sync.
    // Elsewhere with drawer: section refresh only (faster, no layout jump).
    if (hasDrawer && !onCart) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error((data && (data.description || data.message)) || 'Add failed');
          }
          return data;
        });
      })
      .then(function (data) {
        if (onCart) {
          window.location.reload();
          return;
        }
        if (hasDrawer && data.sections && refreshCartSections(data)) {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            try {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'grail-cart-upsell', cartData: data });
            } catch (e) {}
          }
          return;
        }
        window.location.reload();
      })
      .catch(function () {
        btn.textContent = label;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }

  function bindDrawerOpen() {
    if (drawerOpenBound) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawerOpenBound = true;
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('active')) {
        drawer.querySelectorAll('[data-grail-cart-upsell][data-reco-pending="true"]').forEach(scheduleReco);
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    initRoots(document);
    bindDrawerOpen();
    if (!addListenerBound) {
      addListenerBound = true;
      document.body.addEventListener('click', onAddClick);
    }
    if (!cartUpdateBound && typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      cartUpdateBound = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(function () {
          initRoots(document);
        }, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllMobilePagedHeights, 150);
  });

  document.addEventListener('shopify:section:load', function () {
    initRoots(document);
  });
})();
